<template>
  <div class="vtoError vto__page"></div>
</template>

<script>
export default {
  name: 'VtoPageError',
};
</script>
